import { Moment } from 'moment'
import { Tutor } from '@/store/tutors/types'
import { Campus } from '../master/types'
import { periodType } from '../common.types'

export enum ScheduleTypes {
  lesson = 'Lesson',
  subLesson = 'Sub Lesson',
  waiting = 'Waiting',
  workshopOrTutorTraining = 'Workshop / Tutor Training',
  meeting = 'Meeting',
  absent = 'Absent',
}
export type scheduleType = keyof typeof ScheduleTypes

export interface SchedulesState {
  schedules: Schedule[];
}

export interface Schedule {
  id: string
  type: scheduleType
  tutor: Tutor
  campus: Campus
  period: periodType
  date: Moment
  from: Moment
  to: Moment
  memo: string|null
  participantTime: string|null
}
